import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { changeCookieFunc } from "../redux/actions";
import { changeLangFunc } from "../redux/actions";
import "./CookiePopup.css";

const CookiePopup = (props) => {
//   const lang = 'en'
  const cookieContRef=React.useRef(null)
  const lang = useSelector((state) => state.reducer1.lang);
  const dispatch = useDispatch();

  useEffect(() => {
    if(Cookies.get("lang") != undefined){
        if(Cookies.get("lang") == 'jp'){
            dispatch(changeLangFunc());
        }
        cookieContRef.current.style.display="none"
    }


  },[])

  return (
    <div ref={cookieContRef} className="cookieCont">
      <div className="cookieTop">
        <h2>{lang === "en" ? "Cookies" : "クッキー"}</h2>

        <p onClick={
            ()=>{
                cookieContRef.current.style.display="none"
            }
        }>X</p>
      </div>

      {lang === "en" ? (
        <p className="cookieDesc">
          Our website uses cookies for the purpose of convenience and
          maintaining and improving quality. For details, please see our{" "}
          <a href="">privacy policy</a>.
        </p>
      ) : (
        <p className="cookieDesc">
          当社のウェブサイトは、利便性、品質維持・向上を目的に、Cookieを使用しております。詳細については、
          <a href="">プライバシーポリシー</a>をご覧ください。
        </p>
      )}

      <div className="cookieBtnCont">
        <button className="cookieBtn1" onClick={()=>{
            dispatch(changeCookieFunc());
            Cookies.set("lang", "en", { secure: true, expires: 7 });
             cookieContRef.current.style.display="none"

        }}>
          {lang === "en" ? "Accept" : "アペクト"}
        </button>

        <button className="cookieBtn2" onClick={()=>{
            cookieContRef.current.style.display="none"
        }}>
          {lang === "en" ? "Decline" : "衰退"}
        </button>
      </div>
    </div>
  );
};

export default CookiePopup;
